export const TooltipIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 12C8.41421 12 8.75 11.6642 8.75 11.25C8.75 10.8358 8.41421 10.5 8 10.5C7.58579 10.5 7.25 10.8358 7.25 11.25C7.25 11.6642 7.58579 12 8 12Z"
      fill="#636369"
    />
    <path
      d="M8 9V8.5C9.10438 8.5 10 7.71625 10 6.75C10 5.78375 9.10438 5 8 5C6.89562 5 6 5.78375 6 6.75V7"
      stroke="#636369"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z"
      stroke="#636369"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
